import cc from 'classcat';
import { jsx } from 'react/jsx-runtime';
import { svgCls } from './styles/svg.js';

const CircleShape = ({
  fillColor = "currentColor",
  shapeRef,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  strokeColor,
  ...svgProps
}) => {
  return /*#__PURE__*/jsx("svg", {
    ...svgProps,
    className: cc([svgCls, svgProps.className]),
    ref: shapeRef,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 444 444",
    fill: fillColor,
    children: /*#__PURE__*/jsx("path", {
      d: "M222 0C99.4 0 0 99.4 0 222c0 58.9 23.4 115.3 65 157 86.7 86.7 227.3 86.7 314 0s86.7-227.3 0-314C337.4 23.3 280.9-.2 222 0z"
    })
  });
};

export { CircleShape };
//# sourceMappingURL=CircleShape.js.map
